import React, { useState, useEffect } from 'react';
import { LoginCard, PageContainer,RegistrationForm, StyledInput,FieldTitleNew, Button, Footer, CheckboxContainer, CheckboxGrid, BottomCard, CheckBoxContainer, CheckboxCard, ConfirmationText, InputWrapper, EyeIconWrapper,/* CustomToggle, CustomToggleWrapper,*/ ErrorText, ButtonContainer, BorderButton } from './style';
import { ImageUrl } from '../../utils/constants';
import {Divider} from '../../components/Manager/styles';
import { Container } from './style';
// import { DropdownArrow } from '../../utils/icons';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { BackArrowFeed, hidePassword, PasswordEyeIcon, PasswordInfoIcon, RecognitionTickIcon } from '../../utils/icons';
import PasswordPopup from './PasswordPopup';
import { fetchApi } from '../../utils/methods';
import { toast, ToastContainer } from 'react-toastify';
import { SaveUserDetails,VerifyOtpDetails,ResendOtpForComapny,GetAllProducts,GetAllCompanyGoals,SaveCompanyDetails } from '../../redux/constants/apiConstants';
// import { CustomDropdownItemV1, CustomMenuV1, DropdownWrapper } from '../../components/TopBarV3';
// import { Dropdown } from 'react-bootstrap';
// import { IconContainer, StyledImage } from '../../components/TopBarV3/style';
// import { DropIcon } from '../../utils/icons';
import { useCalendlyEventListener,InlineWidget } from "react-calendly";
// import {isNull,isUndefined} from 'lodash';
// import { useDispatch } from "react-redux";
// import i18n from "i18next"; 
// import {putUpdateLanguage,fetchLanguages} from "../../redux/actions";
// import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

function PLGLogin() {
  const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const getLanguages = useSelector((state) => state.companyDashboard.getLanguages);
  // const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const[screen, setScreen] = React.useState("get-started");
  const [focused, setFocused] = React.useState(false);
  const[otp, setOtp] = React.useState('');
  const[registrationRes, setRegistrationRes] = React.useState(null);
  const[registrationToken, setRegistrationToken] = React.useState('');
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [resend, setResend] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [goalsList, setGoalsList] = useState([]);
  const[resendbutton, setResendbutton] = useState(true);
  const [emailTouched, setEmailTouched] = useState(false);
  const [otpError, setOtpError] = useState(false);


  window.console.log("--",registrationRes)

  // let selectedLanguage;

  // if (getLanguages && !isNull(getLanguages) && !isUndefined(getLanguages) && getLanguages.length > 0) {
  //   const selectedLangObj = getLanguages.find((lang) => lang.user_selected === 1);
  //   selectedLanguage = selectedLangObj ? selectedLangObj.name : undefined;
  // }


  // useEffect (()=>{
  //   fetchLanguagesHandler();
  // },[]);

  // const fetchLanguagesHandler = () => {
  //   dispatch(fetchLanguages());
  // };

  // useEffect(() => {
  //   let selectedUserLanguage;

  //   if (getLanguages && !isNull(getLanguages) && !isUndefined(getLanguages)) {
  //     getLanguages?.forEach((language) => {
  //       if (language.user_selected === 1) {
  //         selectedUserLanguage = language.name;
  //       }
  //     });
  //   }

  //   if (isNull(lang)) {
  //     i18n.changeLanguage(selectedUserLanguage);
  //     setLang(selectedUserLanguage);
  //   } else {
  //     i18n.changeLanguage(lang);
  //   }

  //   // setRoleBasedOnPath(); 

  // }, [getLanguages, lang]); 

  // const takeLanguageData = (selectedLang) => {
  //   const userLanguageMap = {
  //     en: "english",
  //     es: "Spanish",
  //     pt: "Portuguese",
  //     fr: "French",
  //   };

  //   const obj = {
  //     user_language: userLanguageMap[selectedLang] || "French",
  //   };

  //   i18n.changeLanguage(selectedLang);
  //   localStorage.setItem("lang", selectedLang);
  //   setLang(selectedLang);
  //   dispatch(putUpdateLanguage(obj));
  // };


  useCalendlyEventListener({
    onEventScheduled: (e) => {
      window.console.log(e.data.payload);
      setScreen("confirm")
    },
    
  });

  const companySizeList = [
    { id: 1, label: '1-99' },
    { id: 2, label: '100-249' },
    { id: 3, label: '250-499' },
    { id: 4, label: '500-999' },
    { id: 5, label: '1000-4999' },
    { id: 6, label: '5000-9999' },
    { id: 7, label: '10000+' },
  ]

  

  const [selectedProducts, setSelectedProducts] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [companyPopup, setCompanyPopup] = React.useState(false);
  const [selectedGoals, setSelectedGoals] = React.useState([]);
  const [selectAllGoals, setSelectAllGoals] = React.useState(false);
  const[state, setState] = React.useState({
    firstName:"",
    lastName:"",
    email:"", 
  });

  const[companyDetails, setCompanyDetails] = React.useState({
    companyName:"",
    companyPassword:"",
  });
  const [showPassword, setShowPassword] = useState(false);

  const [companySize, setCompanySize] = React.useState("");  
  

  const handlePopup =() => {
    setCompanyPopup(true);
  }

  const cancelPopup =() => {
    setCompanyPopup(false);
  }


  useEffect(()=>{
    getAllProductDetails();
    getAllCompanyGoals();
  },[]);

  // useEffect(() => {
  //   if(resend){
  //     if (secondsLeft === 0) {
  //       return;
  //     }
  
  //     const timerId = window.setInterval(() => {
  //       setSecondsLeft((prevSeconds) => prevSeconds - 1);
  //     }, 1000);
  //     return () => window.clearInterval(timerId);
  //   }
   
  // }, [secondsLeft]);



  useEffect(() => {
    if (resend) {
      if (secondsLeft === 0) {
        return () => {}; // always return a function
      }
      const timerId = window.setInterval(() => {
        setSecondsLeft((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => window.clearInterval(timerId);
    }
    return () => {}; //return empty function when resend is false
  }, [secondsLeft]);


  // useEffect(() => {
  //   if (!resend || secondsLeft === 0) return;
  
  //   const timerId = window.setInterval(() => {
  //     setSecondsLeft((prevSeconds) => prevSeconds - 1);
  //   }, 1000);
  
  //   // Cleanup
  //   return () => window.clearInterval(timerId);
  // }, [resend, secondsLeft]);


  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleChange = (event) => {
    setCompanySize(event.target.value);
  };
 
  const SelectProduct = (id)=>{
    const allProducts = [...selectedProducts];
    if (allProducts.includes(id)) {
      let index = allProducts.findIndex((item) => item === id);
      if (index > -1) {
        allProducts.splice(index, 1);
      }
    } else {
      allProducts.push(id);
    }

    setSelectedProducts(allProducts)
  }



  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedProducts([]);
      setSelectAll(false);
    } else {
      const allProductIds = productsList.map((product) => product.id);
      setSelectedProducts(allProductIds);
      setSelectAll(true);
    }
  };

  const SelectGoal = (id)=>{
    const allGoal = [...selectedGoals];
    if (allGoal.includes(id)) {
      let index = allGoal.findIndex((item) => item === id);
      if (index > -1) {
        allGoal.splice(index, 1);
      }
    } else {
      allGoal.push(id);
    }

    setSelectedGoals(allGoal)
  }


  const handleSelectAllGoals = () => {
    if (selectAllGoals) {
      setSelectedGoals([]);
      setSelectAllGoals(false);
    } else {
      const allGoalsIds = goalsList.map((product) => product.id);
      setSelectedGoals(allGoalsIds);
      setSelectAllGoals(true);
    }
  };


  const onChangeInput = (e) => {

    setState((prevState) => ({
      ...prevState,  // Spread the previous state
      [e.target.name]: e.target.value // Update only the field that changed
    }));
  }

  const formatTime = (totalSeconds) => {
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${minutes} : ${seconds}`;
  };


  const onChangeInputForCompany = (e) => {

    setCompanyDetails((prevState) => ({
      ...prevState,  // Spread the previous state
      [e.target.name]: e.target.value // Update only the field that changed
    }));
  }

  //All the API calls

  const saveUsersDetails = async () => {

    const postData = {
      first_name: state.firstName,
      last_name: state.lastName,
      work_email: state.email,
    };

    const apiUrl = `${SaveUserDetails}`;

    try {
      const res = await fetchApi(apiUrl, "POST", postData);
      if (res.status === "success") {
        // toast.success(res.data.message);
        setRegistrationRes(res.data);
        setRegistrationToken(res.data.token);
        setScreen("verificationForm");
        setSecondsLeft(180);
        setResend(true);
      } else {
        window.console.error(res.data.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  const verifyOtpDetails = async () => {

    const payload = {
      otp: parseInt(otp,10),
      token: registrationToken,
      work_email: state.email,
    };

    const apiUrl = `${VerifyOtpDetails}`;

    try {
      const res = await fetchApi(apiUrl, "POST", payload);
      if (res.status === "success") {
        toast.success(res.data.message);
        setScreen("otp");
        setOtpError(false);
      } else {
        // toast.error(res.data.message || "Something went wrong");
        setOtpError(true)
      }
    } catch (error) {
      window.console.error(error);
    }
  };


  const resendOtp = async () => {
    setResendbutton(false);
    const payload = {
      token: registrationToken,
      work_email: state.email,
    };

    const apiUrl = `${ResendOtpForComapny}`;

    try {
      const res = await fetchApi(apiUrl, "POST", payload);

      if (res.status === "success") {
        toast.success(res.data.message);
        setResendbutton(true);
        setSecondsLeft(180);
        // setScreen("otp");
      } else {
        toast.error(res.data.message || "Something went wrong");

      }
    } catch (error) {
      window.console.error(error);
    }
  };


  const saveComapnyDetails = async () => {
    const payload = {
      token: registrationToken,
      work_email: state.email,
      company_name:companyDetails.companyName,
      password: companyDetails.companyPassword,
      company_size: companySize,
      products: selectedProducts,
      goals: selectedGoals,
    };

    const apiUrl = `${SaveCompanyDetails}`;

    try {
      const res = await fetchApi(apiUrl, "POST", payload);

      if (res.status === "success") {
        // toast.success(res.data.message);
        setScreen("calendarComponent");
      } else {
        toast.error(res.data.message || "Something went wrong");

      }
    } catch (error) {
      window.console.error(error);
    }
  };


  const getAllProductDetails = async () => {
   
    const apiUrl = `${GetAllProducts}`;

    try {
      const res = await fetchApi(apiUrl, "Get");

      if (res.status === "success") {
        setProductsList(res.data);
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message || "Something went wrong");

      }
    } catch (error) {
      window.console.error(error);
    }
  }; 


  const getAllCompanyGoals = async () => {
    const apiUrl = `${GetAllCompanyGoals}`;
    try {
      const res = await fetchApi(apiUrl, "Get");

      if (res.status === "success") {
        setGoalsList(res.data);
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message || "Something went wrong");

      }
    } catch (error) {
      window.console.error(error);
    }
  }; 

 

  const WolibaRegistrationForm = () =>{
    // const isNameValid = (name) => name.trim().length >= 2;
    const isNameValid = (name) => {
      const regex = /^[A-Za-z\s]+$/;
      return name.trim().length >= 2 && regex.test(name);
    };
    
    const isEmailValid = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const emailHasError = emailTouched && !isEmailValid(state.email);
  
    return(
     
      <div className="content">
        <LoginCard>
          <div className="formHeading">{t('Create your Woliba account')}</div> 
          <RegistrationForm>
            <FieldTitleNew marginBottom={"12px"}>{t('First name')}</FieldTitleNew>
            <StyledInput  maxLength={100}  marginBottom type="text" placeholder={t('Enter first name')} name='firstName' 
              value={state.firstName}  onChange={onChangeInput}/>
            <FieldTitleNew marginBottom={"12px"}>{t('Last name')}</FieldTitleNew>
            <StyledInput  maxLength={100}  marginBottom type="text" placeholder={t('Enter last name')} name='lastName' 
              value={state.lastName}  onChange={onChangeInput}/> 
            <FieldTitleNew marginBottom={"12px"}>{t('Work email')}</FieldTitleNew>
            <StyledInput maxLength={100} isBorder={emailHasError} type="email" placeholder={t('Enter work email')} name='email' 
              value={state.email}  onChange={onChangeInput}   onBlur={() => setEmailTouched(true)}/>
            {emailHasError && (
              <ErrorText>
                {t('Invalid Email Address')}
              </ErrorText>
            )}
            <Divider isMargin={"20px 0px"}/>
            {/* <Button onClick={() =>{setScreen("verificationForm")}}>Verify Email</Button> */}
            <Button disabled={!isNameValid(state.firstName) || !isNameValid(state.lastName) || !isEmailValid(state.email) } onClick={() => {
              if (!isNameValid(state.firstName) || !isNameValid(state.lastName) || !isEmailValid(state.email)) {
                return;
              }
              saveUsersDetails();
            }}> {t('Verify Email')}</Button>
  
          </RegistrationForm>
        </LoginCard>
      </div>
    )
  }


  const VerificationForm = () => {

    window.console.log("hi");
    return(
      <div className="content">
        <LoginCard isError={otpError}>
          <div className="formHeading">{t('Input verification code')}</div> 
          <div className="otpText">{t('We’ve sent a 6-digit OTP to your email Please enter it below to continue.')}</div>
  
          <div className="flex justify-between">
            {Array.from({ length: 6 }).map((_, index) => (
              <input
                key={index}
                type="number"
                className="otp-input"
                value={otp[index] || ""} // Controlled input
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow single digit input
                  if (value.length > 1) {
                    e.target.value = value.slice(0, 1); // Trim to one digit
                  }
                  const otpArray = otp.split(""); // Convert current OTP string to an array
                  otpArray[index] = e.target.value; // Set the value in the correct index
                  setOtp(otpArray.join(""));
                  // Move focus to the next input if the current one is filled
                  if (value && index < 7) {
                    const next = e.target.nextElementSibling;
                    if (next) next.focus();
                  }
                }}
                onKeyDown={(e) => {
                  // Move focus to previous input on backspace if empty
                  if (e.key === "Backspace" && e.target.value === "") {
                    const prev = e.target.previousElementSibling;
                    if (prev) prev.focus();
                  }
                  // Move focus to the next input on arrow right if filled
                  if (e.key === "ArrowRight" && e.target.value) {
                    const next = e.target.nextElementSibling;
                    if (next) next.focus();
                  }
                  // Move focus to the previous input on arrow left if empty
                  if (e.key === "ArrowLeft" && e.target.value === "") {
                    const prev = e.target.previousElementSibling;
                    if (prev) prev.focus();
                  }
                }}
                onFocus={(e) => e.target.select()} // Select the input value on focus
                // disabled={index > 0 && !loginDetails.otp[index - 1]} // Disable next fields if the previous one is not filled
              />
            ))}
          </div>
          {otpError ? <ErrorText >Incorrect OTP</ErrorText>: null}
          {(secondsLeft !== 0 && resendbutton) ? <div className="resendText">
            Resend OTP in {formatTime(secondsLeft)}
            {/* Resend OTP in {secondsLeft} second{secondsLeft !== (1 || 0)  ? 's' : ''} */}
          </div> : <div className="resendButton" onClick={resendOtp}>  {t("Resend")}</div>  }
          <Divider isMargin={"20px 0px"}/>
          {/* <Button onClick={() =>{setScreen("otp")}}>Verify Email</Button> */}
          <ButtonContainer>
            <BorderButton onClick={() =>{setScreen("get-started")}}>
              <div className="arrowTextContainer">
                {BackArrowFeed("#F37A65")}
                {t("Back")}
              </div>
            </BorderButton>
            <Button disabled={otp.length!==6 } onClick={() =>{ otp.length!==6 ? null : verifyOtpDetails()}}> {t("Submit")}</Button>
          </ButtonContainer>
        </LoginCard>
      </div>
    )}

  const otpForm = () => {
    window.console.log("hi");
    return(
      <div className="content">
        <LoginCard isFontSize={"24px"} isLineHeight={"36px"}>
          <div className="formHeading">{t('Hi')} {state.firstName}!</div> 
          {/* <div className="formHeading">{t('About your company')}</div>  */}
          <RegistrationForm>
            <FieldTitleNew marginBottom={"12px"}> {t('What is your company name?')}</FieldTitleNew>
            <StyledInput  marginBottom type="text" placeholder={t('Enter company name')} name='companyName' 
              value={companyDetails.companyName} onChange={onChangeInputForCompany}
            />
            <div className="companyContainer">
              <FieldTitleNew  marginBottom={"12px"}>{t('Set company password')}</FieldTitleNew>
              <div className="iconContainer" onClick={handlePopup}>{PasswordInfoIcon()}</div>
            </div>
            {/* <StyledInput marginBottom type="password" placeholder='Enter company password' name='password' 
              // value={details.fname} onChange={(e) => this.onChangeInput(e, index)
            />
            <div>{PasswordEyeIcon()}</div> */}
            <InputWrapper>
              <StyledInput
                maxLength={"50"}
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter company password"
                name="companyPassword"
                value={companyDetails.companyPassword}
                onChange={onChangeInputForCompany}
              />
              <EyeIconWrapper onClick={togglePasswordVisibility}>
                <span className='icon'>{ showPassword ? hidePassword() : PasswordEyeIcon() }</span>
              </EyeIconWrapper>
            </InputWrapper>
         
            <Divider isMargin={"20px 0px"}/>

            <ButtonContainer>
              <BorderButton autoMargin onClick={() =>{setScreen("verificationForm")}}>
                <div className="arrowTextContainer">
                  {BackArrowFeed("#F37A65")}
                  {t("Back")}
                </div>
              </BorderButton>
              <Button autoMargin disabled={!companyDetails.companyName || !companyDetails.companyPassword}   onClick={() => {
                if (!companyDetails.companyName || !companyDetails.companyPassword ) {
                  toast.error("Please enter valid details.");
                  return;
                }
                setScreen("companySizeForm")
              }}>{t('Next')}</Button>
            </ButtonContainer>
  
          </RegistrationForm>
        </LoginCard>
        {companyPopup && <PasswordPopup show={companyPopup} onCancel={cancelPopup} />}
      </div>)
  }


  const CompanysizeForm = () => {
    window.console.log("hi");
    return(
      <div className="content">
        <LoginCard isFontSize={"24px"} isLineHeight={"36px"}>
          <div className="formHeading">{t('How many employees do you have')}</div> 
          <div className="formHeading">{t('at')} {companyDetails.companyName}?</div> 
          <RegistrationForm>
            <FieldTitleNew marginBottom={ !companySize ? "12px" : "20px"}> {t('Company size')}</FieldTitleNew>
            <FormControl
              id="form"
              fullWidth
              variant="outlined"
              sx={{
                // marginTop: "12px",
                borderRadius: "4px",
                // padding: "14px 16px",
                "  & .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: focused ? "#F37A65" : "#BDBDBD",
                  },
                  "&:hover fieldset": {
                    borderColor: "#BDBDBD",
                  },
                  "&.Mui-focused fieldset": {
                    border:"1px solid #F37A65",
                  },
                },
              }}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
            >
              <InputLabel
                id="select-size-label"
                sx={{
                  fontFamily: "Lato",
                  fontSize: "16px",
                  // marginLeft:"24px",
                  // marginTop:"10px",
                  top:'-4px',
                  color: focused ? "#F37A65" : "#BDBDBD",
                  "&.Mui-focused": {
                    color: "#F37A65",
                  },
                }}
              >
                {(focused  || companySize) ? t("Selected option") : t("Select company size")}
              </InputLabel>
              <Select
                labelId="select-size-label"
                id="select-recognition"
                value={companySize}
                onChange={handleChange}
                label="Select recognition"
                sx={{
                  color: "#184A61",
                  width: "100%",
                  height:"48px",
                  padding:"14px 16px",
                  "& .MuiSelect-icon": {
                    color: "#F37A65",
                    top: "50%",
                    right: "12px", 
                    transform: "translateY(-50%)",
                    // fontSize: "16px",
                    width: "30px",
                    height: "30px",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 200,
                      width: 300,
                      
                      "&::-webkit-scrollbar": {
                        width: "4px",
                        height: "100px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#BDBDBD",
                        borderRadius: "5.5px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "white",
                      },
                    },
                  },
                  MenuListProps: {
                    sx: {
                      paddingTop: 0,
                      paddingBottom: 0,
                    },
                  },
                }}
              >
                {(Array.isArray(companySizeList)
                  ? companySizeList
                  : []
                ).map((item, index) => (
                  <MenuItem
                    id="menu-item"
                    key={index}
                    value={item.label}
                    
                    sx={{
                      color: "#184A61",
                      padding: "14px 16px",
                      "&:hover": { backgroundColor: "#FEF4F2",color:"#184A61" },
                      "&.Mui-selected": {
                        backgroundColor: "#F37A65 !important",
                        color:"#FFFFFF !important",
                      },
                     
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
         
            <Divider isMargin={"20px 0px"}/>

            <ButtonContainer>
              <BorderButton autoMargin onClick={() =>{setScreen("otp")}}>
                <div className="arrowTextContainer">
                  {BackArrowFeed("#F37A65")}
                  {t("Back")}
                </div>
              </BorderButton>
              <Button autoMargin disabled={!companySize} onClick={()=>{ !companySize ?  null :setScreen("productFrom")}}>{t("Next")}</Button>
            </ButtonContainer>
          </RegistrationForm>
        </LoginCard>
      </div>)
  }


  const ProductForm = () => {
    window.console.log("hi");
    return(
      <div className="content">
        <CheckboxContainer isFontSize={"24px"} isLineHeight={"36px"}>
          <div className="heading">{t('What products would you like to use?')}</div>
          <CheckboxGrid>
            
            {productsList.map((product, index)=>(
              <CheckboxCard key={index + product.id}  onClick={()=>SelectProduct(product.id)}>
                <CheckBoxContainer selected={selectedProducts.includes(product.id) ? true : false}>
                  <div className="archive-action" >{selectedProducts.includes(product.id) ?  RecognitionTickIcon() : null}</div>
                </CheckBoxContainer>
                <span className='productName' title={product.product_name}>{product.product_name}</span>
              </CheckboxCard>
            ))}
            
          </CheckboxGrid>
          <Divider isMargin={"20px 0px"}/>
          <BottomCard>
            <div className="SelectAllCard">
              <div className="containerCard" onClick={()=>handleSelectAll()}>
                <CheckBoxContainer selected={selectedProducts.length ===  productsList.length ? true : false}>
                  <div className="archive-action" >{selectedProducts.length ===  productsList.length  ?  RecognitionTickIcon() : null}</div>
                </CheckBoxContainer>
                <span className='productName'>{t('Select all products')}</span>
              </div>
            </div>
            <div className="centerButton">
              <BorderButton autoMargin onClick={() =>{setScreen("companySizeForm")}}>
                <div className="arrowTextContainer">
                  {BackArrowFeed("#F37A65")}
                  {t("Back")}
                </div>
              </BorderButton>
              <Button isButtonWidth={"200px"}  disabled={!selectedProducts.length} onClick={()=>{ !selectedProducts.length ? null :  setScreen("goalFrom")}}> {t("Next")}</Button>
            </div>
          </BottomCard>
        </CheckboxContainer>
      </div>

    )}



  const GoalsForm = () => {
    window.console.log("hi");
    return(
      <div className="content">
        <CheckboxContainer isMaxWidth={"1414px"} isFontSize={"24px"} isLineHeight={"36px"}>
          <div className="heading">{t('What goals do you want to achieve?')}</div>
          <CheckboxGrid>
            
            {goalsList.map((goals, index)=>(
              <CheckboxCard isCardWidth={"330px"}  key={index + goals.id}  onClick={()=>SelectGoal(goals.id)}>
                <CheckBoxContainer selected={selectedGoals.includes(goals.id) ? true : false}>
                  <div className="archive-action" >{selectedGoals.includes(goals.id) ?  RecognitionTickIcon() : null}</div>
                </CheckBoxContainer>
                <span className='productName' title={goals.name}>{goals.name}</span>
              </CheckboxCard>
            ))}
            
          </CheckboxGrid>
          <Divider isMargin={"20px 0px"}/>
          <BottomCard isMarginLeft={"345px"}>
            <div className="SelectAllCard">
              <div className="containerCard" onClick={()=>handleSelectAllGoals()}>
                <CheckBoxContainer selected={selectedGoals.length ===  goalsList.length ? true : false}>
                  <div className="archive-action" >{selectedGoals.length ===  goalsList.length  ?  RecognitionTickIcon() : null}</div>
                </CheckBoxContainer>
                <span className='productName'>{t('Select all goals')}</span>
              </div>
            </div>
            <div className="centerButton">
              <BorderButton autoMargin onClick={() =>{setScreen("productFrom")}}>
                <div className="arrowTextContainer">
                  {BackArrowFeed("#F37A65")}
                  {t("Back")}
                </div>
              </BorderButton>
              <Button isButtonWidth={"200px"} disabled={!selectedGoals.length} onClick={ !selectedGoals.length ? null : saveComapnyDetails}> {t("Next")}</Button>
            </div>
          </BottomCard>
        </CheckboxContainer>
      </div>

    )}


  const CalendarComponent = () =>{
    window.console.log("hi");
    return(
      <div className="content" style={{overflowY:"hidden",position: "relative",marginBottom:"20px" }}>
        
        <div style={{width:"1072px", height: '684px', overflowY:"hidden",position:"relative" }} data-resize="true">
          {/* <ConfirmationText style={{position: "relative",top:"100px" }} isSize={"18px"}>Setup a meeting below with a Woliba team member to launch your program.</ConfirmationText> */}
          <InlineWidget styles={{zIndex:"25"}} url=" https://calendly.com/d/cvzy-fn4-g5w/ready-to-launch-your-woliba-portal-let-s-do-this"/>
          {/* <BorderButton style={{position:"absolute",top:"700px",right:"863px",zIndex:"10",bottom:"0px"}} autoMargin onClick={() =>{setScreen("goalFrom")}}>
            <div className="arrowTextContainer">
              {BackArrowFeed("#F37A65")}
              {t("Back")}
            </div>
          </BorderButton> */}
        </div>
      </div>
    )
  }


  const ConfirmationScreen = () =>{
    window.console.log("hi");
    return(
      <div className="content" style={{overflowY:"hidden"}}>
        <div style={{display:'flex',flexDirection:'column',marginTop:"300px",height:'100%',padding:"0px 60px"}}>
          <ConfirmationText isSize={"32px"}>{t("Perfect!")}</ConfirmationText>
          <ConfirmationText  isSize={"24px"} isWeight={"700"} isLine={"52px"}>{t("We’ve sent a confirmation to your email with the call details.")}</ConfirmationText>
          <ConfirmationText isSize={"24px"} isWeight={"700"} isLine={"52px"}>{t(" A separate email has also been sent to your registered email address with login details to access Woliba.")}</ConfirmationText>
        </div>
      </div>
    )
  }
  

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
      <PageContainer
        style={{
        // backgroundImage: `url(${ImageUrl}/plg/plg_registration.png)`,
          backgroundImage: `url(${ImageUrl}/plg/${
            screen === 'otp' ? 'company_form.png' : screen === "companySizeForm"  ?  'company_people.png' :   screen === 'get-started' || screen === 'verificationForm'  ? 'plg_registration.png':  screen === "confirm" ? 'confirmation.png' :  screen === "productFrom" || screen === "goalFrom"  ?  'Product_Goals.png'  : null})`,
          // backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width:'100vw',
          height: '100vh',
          backgroundSize:
      screen === 'otp'  ?
        '1820px 450px'
        : screen === 'companySizeForm'
          ? '1235px 535px'
          : screen === 'get-started' || screen === 'verificationForm'
            ? '1400px 700px'
            : screen === 'confirm'
              ? '1270px 800px' : screen === "productFrom" || screen === "goalFrom" ?  '1550px 700px': 'cover',
        }}>
        <Container>
          {/* Logo */}
          <div style={{  display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '40px', // match logo position
            position: 'relative' }}>
            <div>
              <img
                src={`${ImageUrl}/images/Logo/woliba-logo.png`}
                alt="Woliba Logo"
                style={{
                  // position: 'absolute',
                  // top: '30px',
                  // left: '40px',
                  width: '146px',
                }}
              />
            </div>
           
           
          </div>
         
       
          {screen === "get-started" ? WolibaRegistrationForm(): screen === "confirm" ?  ConfirmationScreen(): screen ==="verificationForm" ? VerificationForm():screen === "otp" ? otpForm(): screen === "companySizeForm" ? CompanysizeForm(): screen ==="productFrom" ? ProductForm(): screen==="goalFrom" ? GoalsForm() : screen === "calendarComponent" ? CalendarComponent() :null}
       
          {screen !== "confirm" && <Footer> 
            <div className="linkContainer">
              <a 
                className="termText" 
                href="https://woliba.io/terms-of-use" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                Terms of Use
              </a>
              <a 
                className="termText" 
                href="https://woliba.io/contact/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
               Contact Us
              </a>
            </div> 
            {/* <div className="copyrightText"> © 2025 Training Amigo LLC. All Rights Reserved</div> */}
          </Footer>  }
        </Container>
      </PageContainer>
    </>
  );
}

export default PLGLogin;
